import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Advisory before transaction",
    body: "Traditional brokers sell aircraft. We advise clients — and we trade, source and transact on their behalf. Every recommendation is backed by market intelligence and technical review before it reaches your desk.",
  },
  {
    n: "02",
    title: "Data becomes decision",
    body: "Current market value, historical comparables, engine trends, residual value, lease rates and operator history — the same rigor a private-equity desk applies to any investment thesis.",
  },
  {
    n: "03",
    title: "Value in every mandate",
    body: "Advisory, sourcing, asset trading or transaction execution — the objective is always the same: maximize value while minimizing commercial and technical risk.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="relative py-32 md:py-40 border-t border-[#0E1B2E]/10 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-24">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3 text-[#A5854C] mb-6">
              <div className="hairline w-12"></div>
              <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Why we exist</span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif font-light tracking-[-0.02em] text-[#0E1B2E] text-[36px] md:text-[56px] lg:text-[72px] leading-[1.02]"
            >
              Advisory over brokerage. <span className="italic text-[#A5854C]">Always.</span>
            </motion.h2>
          </div>
        </div>

        <div className="space-y-2 md:space-y-0">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="grid grid-cols-12 gap-8 border-t border-[#0E1B2E]/10 py-14 group"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="col-span-12 md:col-span-2">
                <span className="font-serif text-[64px] md:text-[96px] leading-none text-[#C8A97E]/40 group-hover:text-[#C8A97E]/80 transition-colors duration-500">
                  {c.n}
                </span>
              </div>
              <div className="col-span-12 md:col-span-4">
                <h3 className="font-serif text-[24px] md:text-[32px] tracking-tight text-[#0E1B2E] leading-tight">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-6">
                <p className="text-[#445060] text-[15px] md:text-[17px] leading-[1.7] max-w-xl">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
